import { useQuery } from "@tanstack/react-query";

import { SupplyFlowParams, getSupplyFlow } from "../../services/productPlaneApi";
import { queryKeys } from "./keys";

const STALE_TIME = 60 * 1000;
const GC_TIME = 5 * 60 * 1000;

/**
 * TanStack Query hook for the supply flow of a selection of products.
 *
 * The caller builds the request from the selection and the jurisdictions.
 */
export function useSupplyFlow(params: SupplyFlowParams, enabled = true) {
  return useQuery({
    queryKey: queryKeys.productPlane.supplyFlow(params),
    queryFn: () => getSupplyFlow(params),
    enabled,
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
  });
}
